import React from 'react';
import styled from 'styled-components';
import { border, color, shadow, space, layout, flexbox, } from 'styled-system';
const Component = styled.div `
  ${border}
  ${color}
  ${shadow}
  ${space}
  ${flexbox}
  ${layout}

  ${({ hasRoundedCorner }) => (hasRoundedCorner ? 'border-radius: 8px' : '')};
`;
export const Box = ({ htmlAttrs = {}, ...rest }) => (React.createElement(Component, { ...htmlAttrs, ...rest }));
Box.defaultProps = {
    boxShadow: 'x0',
    hasRoundedCorner: false,
};
//# sourceMappingURL=index.js.map